import React, { FC } from "react";

import { useQuery } from "react-query";

import { brokerApi } from "@/shared/apis";
import { useAuth } from "@/shared/hooks";

import { InfoPanel, LoginPanel } from "./components";
import { InfoPanelProps } from "./components/InfoPanel/InfoPanel";
import { StyledSuccessPage } from "./styled";

type SuccessPageProps = Omit<InfoPanelProps, "loginNeeded">;

const SuccessPage: FC<SuccessPageProps> = ({ icon, message, actionButton }) => {
    const { user, scopeOptions } = useAuth();

    const { data: brokerSettings, isLoading } = useQuery(["brokerSettings", { officeId: user.officeId }], () =>
        brokerApi.getBrokerSettings(),
    );

    const loginNeeded = user.isScopedLogin() && scopeOptions.onlyAllowedRoutes;

    return (
        <StyledSuccessPage data-testid="success-page">
            <InfoPanel icon={icon} message={message} loginNeeded={loginNeeded} actionButton={actionButton} />
            {loginNeeded && !isLoading && brokerSettings?.isPromoteMyBroker && <LoginPanel />}
        </StyledSuccessPage>
    );
};

export default SuccessPage;
